module.exports = __webpack_public_path__ + "img/pick-correct.3c626ee5.svg";